module.exports = __webpack_public_path__ + "static/media/mapbox-satellite.012043de.jpg";